import { CloseOutlined } from '@ant-design/icons';
import { useEffect, useRef } from 'react';
import type { useAdminVisitedTabs } from './useAdminVisitedTabs';

export type AdminVisitedTabsController = ReturnType<typeof useAdminVisitedTabs>;

export function AdminVisitedTabs({
  controller,
}: {
  controller: AdminVisitedTabsController;
}) {
  const { tabs, activeTabId, activateTab, closeTab } = controller;
  const activeTabRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    activeTabRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }, [activeTabId]);

  return (
    <div className="admin-visited-tabs" aria-label="已打开页面">
      <div className="admin-visited-tabs__scroll" role="tablist">
        {tabs.map(tab => {
          const active = tab.id === activeTabId;
          return (
            <div
              key={tab.id}
              ref={active ? activeTabRef : undefined}
              className={`admin-visited-tab${active ? ' admin-visited-tab--active' : ''}${tab.closable ? ' admin-visited-tab--closable' : ''}`}
            >
              <button
                type="button"
                role="tab"
                aria-selected={active}
                className="admin-visited-tab__main"
                title={tab.group ? `${tab.group} / ${tab.label}` : tab.label}
                onClick={() => activateTab(tab)}
              >
                <span className="admin-visited-tab__dot" aria-hidden="true" />
                <span className="admin-visited-tab__label">{tab.label}</span>
              </button>
              {tab.closable ? (
                <button
                  type="button"
                  className="admin-visited-tab__close"
                  aria-label={`关闭${tab.label}`}
                  title={`关闭${tab.label}`}
                  onClick={event => {
                    event.stopPropagation();
                    closeTab(tab.id);
                  }}
                >
                  <CloseOutlined />
                </button>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
